// export const visaRegx = new RegExp("^4\\d{0,15}");
// export const mastercardRegx = new RegExp(
//   "^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}"
// );
// export const americanExpressRegx = new RegExp("^3[47]\\d{0,13}");
// export const jcbRegx = new RegExp("^(?:35\\d{0,2})\\d{0,12}");
// export const discoverRegx = new RegExp(
//   "^(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}"
// );
// export const dinersRegx = new RegExp("^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}");
// export const maestroRegx = new RegExp(
//   "^(?:5[0678]\\d{0,2}|6304|67\\d{0,2})\\d{0,12}"
// );
// export const unionpayRegx = new RegExp("^62\\d{0,14}");

export const getCardType = (number: string) => {
  // visa
  var re = new RegExp("^4");
  if (number.match(re) != null)
    return {
      type: "visa",
      cardMask: "0000 0000 0000 0000",
      cvcMask: "000",
    };

  // Mastercard
  // Updated for Mastercard 2017 BINs expansion
  if (
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
      number
    )
  )
    return {
      type: "mastercard",
      cardMask: "0000 0000 0000 0000",
      cvcMask: "000",
    };

  // AMEX
  re = new RegExp("^3[47]");
  if (number.match(re) != null)
    return {
      type: "amex",
      cardMask: "0000 000000 00000",
      cvcMask: "0000",
    };

  // Discover
  re = new RegExp(
    "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)"
  );
  if (number.match(re) != null)
    return {
      type: "discover",
      cardMask: "0000 0000 0000 0000",
      cvcMask: "000",
    };

  // Diners
  re = new RegExp("^36");
  if (number.match(re) != null)
    return {
      type: "diners_club",
      cardMask: "0000 0000 0000 0000",
      cvcMask: "000",
    };

  // Diners - Carte Blanche
  re = new RegExp("^30[0-5]");
  if (number.match(re) != null)
    return {
      type: "Diners - Carte Blanche",
      cardMask: "0000 0000 0000 0000",
      cvcMask: "000",
    };

  // JCB
  re = new RegExp("^35(2[89]|[3-8][0-9])");
  if (number.match(re) != null)
    return {
      type: "jcb",
      cardMask: "0000 0000 0000 0000",
      cvcMask: "000",
    };

  // Visa Electron
  re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
  if (number.match(re) != null)
    return {
      type: "Visa Electron",
      cardMask: "0000 0000 0000 0000",
      cvcMask: "000",
    };

  re = new RegExp("^62\\d{0,14}");
  if (number.match(re) != null)
    return {
      type: "unionpay",
      cardMask: "0000 0000 0000 0000",
      cvcMask: "000",
    };

  return {
    type: "Default",
    cardMask: "0000 0000 0000 0000",
    cvcMask: "000",
  };
};
